import { mondayOf, shiftWeeks, ymdInTimezone } from '@loop3/dates'

const TIMEZONE = 'America/Argentina/Buenos_Aires'
const WEEKS_SHOWN = 6

/** Today in ART, the Monday of this ART week, and the six-week journal window ending today. */
export function journalWindow(now: Date) {
  const today = ymdInTimezone(now, TIMEZONE)
  const thisWeek = mondayOf(today)
  return {
    thisWeek,
    from: shiftWeeks(thisWeek, -(WEEKS_SHOWN - 1)),
    to: today,
  }
}
